import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export function makeApi(getToken) {
  const instance = axios.create({ baseURL: API });
  instance.interceptors.request.use(async (cfg) => {
    try {
      const token = await getToken();
      if (token) cfg.headers.Authorization = `Bearer ${token}`;
    } catch {}
    return cfg;
  });
  return instance;
}
